export const getFormattedDistanceFromValue = (distance) => {
  return distance
    ? distance >= 1000
      ? `${(distance / 1000.0).toFixed(1)}km`.replace(".0", "")
      : `${distance}m`
    : null
}
